import { isValid, parseISO, subYears } from 'date-fns';
import * as yup from 'yup';

export const BvnValidationSchema = yup.object({
	directorBvn: yup
		.string()
		.min(11, 'BVN must be at least 11 characters')
		.max(11, 'BVN must be at most 11 characters')
		.required('BVN is required'),
	directorDob: yup
		.string()
		.required('Date of birth is required')
		// parseISO (local) matches how the picker reads/writes the value, so validation can't disagree with
		// the calendar over a timezone boundary. Mirror the calendar's bounds: not in the future, within 120y.
		.test('valid-dob', 'Enter a valid date of birth', (value) => {
			if (!value) return false;
			const parsed = parseISO(value);
			if (!isValid(parsed)) return false;
			const now = new Date();
			return parsed <= now && parsed >= subYears(now, 120);
		}),
});
